import { createContext, useContext } from 'react';
import type { ToastContextModel } from '../../type/toast';

export const ToastContext = createContext<ToastContextModel | undefined>(undefined);

export const useToast = (): ToastContextModel => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};
